import React, { useState, useEffect } from 'react';
import './Header.css';

export default function HeaderToronto({ province = 'Alberta' }) {
  const [open, setOpen] = useState(false);

  // Close menu when clicking outside
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (open && !e.target.closest('.main-nav') && !e.target.closest('.hamburger')) {
        setOpen(false);
      }
    };
    document.addEventListener('click', handleClickOutside);
    return () => document.removeEventListener('click', handleClickOutside);
  }, [open]);

  // Prevent body scroll when menu is open
  useEffect(() => {
    if (open) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [open]);

  return (
    <header className="site-header">
      <div className="container">
        <div className="brand">TestG1</div>
        <button 
          className={`hamburger ${open ? 'active' : ''}`} 
          aria-label={open ? "Close menu" : "Open menu"}
          aria-expanded={open}
          onClick={() => setOpen(o => !o)}
        >
          <span className="hamburger-line"></span>
          <span className="hamburger-line"></span>
          <span className="hamburger-line"></span>
        </button>
        <nav className={`main-nav ${open ? 'open' : ''}`}>
          <div className="nav-links">
            <select className="province-select" defaultValue={province} aria-label="Select province">
              <option>Alberta</option>
              <option>BC</option>
              <option>Ontario</option>
            </select>
            <a href="https://www.facebook.com/profile.php?id=61581419279911" className="nav-link">Community</a>
            <a href="#contact" className="nav-link">Contact us</a>
            <a href="#premium" className="nav-link cta">Premium Login</a>
          </div>
        </nav>
        {open && <div className="nav-overlay" onClick={() => setOpen(false)}></div>}
      </div>
    </header>
  );
}
